import createIcon from '../../createIcon';

/**
 * @component @name Headphones
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0M3LjAzIDMgMyA3LjAzIDMgMTJWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDlWMTNINVYxMkM1IDguMTMgOC4xMyA1IDEyIDVDMTUuODcgNSAxOSA4LjEzIDE5IDEyVjEzSDE1VjIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxMkMyMSA3LjAzIDE2Ljk3IDMgMTIgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Headphones = createIcon('Headphones', [
  [
    'path',
    {
      d: 'M12 3C7.03 3 3 7.03 3 12V19C3 20.1 3.9 21 5 21H9V13H5V12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12V13H15V21H19C20.1 21 21 20.1 21 19V12C21 7.03 16.97 3 12 3Z',
      key: '137xre',
    },
  ],
]);

export default Headphones;
